import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import colors from '../ui/colors';

const StyledFooter = styled.footer`
  font-size: 0.875rem;
  align-items: center;
  justify-content: center;
  line-height: 1.5rem;
  padding: 0.75rem 0 1.5rem;
  margin-top: 2rem;
  border-top: 1px solid #9B9B9B;
  box-sizing: border-box;
  display: flex;
  flex: 1 0;
  min-height: 3.75rem;
  max-height: 3.75rem;

  a {
    flex: 1;
    text-align: center;
    color: ${colors.BRAND_GREEN};
    cursor: pointer;
  }

  span {
    margin: 0 1rem;
    width: 1px;
    display: block;
    border-right: 1px solid #9B9B9B;
    height: 1.5rem;
  }
`;

const PopupFooter = (props) => {
  const {linkLabel, linkTarget} = props;
  return (
    <StyledFooter>
      <Link 
        to={linkTarget}
      >{linkLabel}</Link>
    </StyledFooter>
  );
};

export default PopupFooter;


// WEBPACK FOOTER //
// ./src/modules/common/components/popup/PopupFooter.js